import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { darken, styled } from '@mui/material/styles';
import { green, orange, red } from '@mui/material/colors';
import MuiKeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export const UserOrApproverRender = styled(Stack, { label: 'UserOrApproverRender' })(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  gap: theme.spacing(1),
  width: '100%',
  height: '32px',
}));

export const UserOrApproverRoot = styled(Stack, { label: 'UserOrApproverTag' })(() => ({
  justifyContent: 'center',
  alignItems: 'center',
}));

const createStatusColors = (theme, isLevel) => ({
  draft: {
    backgroundColor: theme.palette.common.white,
    color: 'inherit',
    '&&:hover': {
      backgroundColor: darken(theme.palette.common.white, 0.05),
    },
  },
  pending: {
    backgroundColor: isLevel ? orange[50] : orange[100],
    color: 'inherit',
    borderColor: isLevel ? theme.palette.warning.light : theme.palette.warning.main,
    '&&:hover': {
      backgroundColor: isLevel ? darken(orange[50], 0.05) : darken(orange[100], 0.05),
    },
  },
  approved: {
    backgroundColor: isLevel ? green[50] : green[100],
    color: 'inherit',
    borderColor: isLevel ? theme.palette.success.light : theme.palette.success.main,
    '&&:hover': {
      backgroundColor: isLevel ? darken(green[50], 0.05) : darken(green[100], 0.05),
    },
  },
  rejected: {
    backgroundColor: isLevel ? red[50] : red[100],
    color: 'inherit',
    borderColor: isLevel ? theme.palette.error.light : theme.palette.error.main,
    '&&:hover': {
      backgroundColor: isLevel ? darken(red[50], 0.05) : darken(red[100], 0.05),
    },
  },
});

export const CustomChip = styled(Chip, {
  label: 'UserOrApproverChip',
  shouldForwardProp: (propName) => !['isLevel', 'direction', 'withoutBorderForLevelContainer'].includes(propName),
})(({ theme, status, isLevel, direction, withoutBorderForLevelContainer }) => ({
  ...(status
    ? createStatusColors(theme, isLevel)[status]
    : {
        backgroundColor: theme.palette.common.white,

        '& .MuiChip-deleteIcon': {
          color: theme.palette.grey[300],
        },
      }),

  ...(isLevel &&
    direction === 'column' && {
      display: 'inline-table',
      '& .MuiChip-label': {
        display: 'block',
        padding: theme.spacing(1),
      },
    }),

  ...(isLevel && withoutBorderForLevelContainer && { border: 'none' }),

  minWidth: 0,

  '&.dnd-dragging': {
    outline: '2px solid',
    outlineColor: theme.palette.primary.main,

    '&.dnd-error': {
      outlineColor: theme.palette.error.main,
    },
  },
}));

const sizes = {
  large: 1.5,
  medium: 1,
  small: 0.5,
};

export const KeyboardArrowRightIcon = styled(MuiKeyboardArrowRightIcon, {
  shouldForwardProp: (prop) => prop !== 'arrowDirection',
})(({ theme, arrowDirection, fontSize }) => ({
  margin: theme.spacing(0, -sizes[fontSize]),
  transform: `rotate(${theme.direction === 'rtl' ? 180 : 0}deg)`,
  ...(arrowDirection === 'column' && { transform: 'rotate(90deg)' }),
}));
